import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Field, reduxForm, change, getFormValues } from 'redux-form';
import moment from 'moment';
import { currencyFormatter } from 'utils/formatter';
import { Link } from 'react-router';
import {
  hidePurchaseStaffSlotModal,
  verifyAddStaffSlot,
} from 'actions/employees/staff';
import styles from './PurchaseStaffSlotModal.css';

class PurchaseStaffSlotModal extends React.Component {
  render() {
    const {
      showPurchaseStaffSlotModal,
      formValues,
      featurePrice,
      pendingBilling,
    } = this.props;

    return (
      <Modal
        onHide={() => this._hideModal()}
        show={showPurchaseStaffSlotModal}
        dialogClassName={`${styles['add-slot-wrapper']} modal-dialog`}
      >
        <Modal.Body bsClass={styles['modal-wrapper']}>
          <button
            type="button"
            className="close"
            onClick={() => {
              this._hideModal();
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className={styles.title}>
            <h4 style={{ fontWeight: 'bold' }}>Buy Employee Slots</h4>
          </div>
          <hr />
          <div className="row" style={{ verticalAlign: 'middle' }}>
            <div className="col-xs-4">
              <span style={{ lineHeight: '34px' }}>Number of Slots</span>
            </div>
            <div className={`col-xs-3`}>
              <div className={`input-group ${styles.spinner}`}>
                <Field
                  type="text"
                  name="slotNumber"
                  component="input"
                  className={`form-control ${styles['slot-number']}`}
                  onChange={e => {
                    const { value } = e.target;
                    if (!isNaN(value) && value > 0) {
                      this.props.dispatch(
                        change('PurchaseStaffSlotForm', 'slotNumber', value)
                      );
                    } else {
                      // default value
                      this.props.dispatch(
                        change('PurchaseStaffSlotForm', 'slotNumber', 1)
                      );
                    }
                    e.preventDefault();
                  }}
                />
                <div className={styles['input-group-btn-vertical']}>
                  <button
                    className="btn btn-default"
                    type="button"
                    onClick={() => {
                      this._upButton();
                    }}
                  >
                    <i className="fa fa-caret-up" />
                  </button>
                  <button
                    className="btn btn-default"
                    type="button"
                    onClick={() => this._downButton()}
                  >
                    <i className="fa fa-caret-down" />
                  </button>
                </div>
              </div>
            </div>
            <div className="col-xs-5">
              <div className={styles.right}>
                <span className={styles['pricing-text']}>
                  {featurePrice && currencyFormatter(featurePrice.final_price)}
                </span>
                <br />
                {/* TODO end date must be the longest exp date of outlet */}
                <span className={styles['pro-rated-period-text']}>
                  Pro-rated for period from {moment().format('DD/MM/YYYY')} -{' '}
                  {moment(
                    featurePrice && featurePrice['Slot Employee'].end_date
                  ).format('DD/MM/YYYY')}
                </span>
                <div />
              </div>
            </div>
          </div>
          <hr />
          <div className="row text-primary">
            <div className="col-xs-5">
              <h3 className={styles['payment-total-message']}>Total Payment</h3>
            </div>
            <div className={`col-xs-7 ${styles.right}`}>
              {/* TODO remove the hardcode price */}
              <h3 className={styles['payment-total-message']}>
                {formValues &&
                  featurePrice &&
                  currencyFormatter(
                    formValues.slotNumber * featurePrice.final_price
                  )}
              </h3>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-xs-12">
              <button
                type="button"
                id="pay-button"
                className={
                  pendingBilling
                    ? `btn btn-default btn-disabled btn-lg ${
                        styles['pay-disabled']
                      }`
                    : 'btn btn-primary btn-lg btn-block'
                }
                onClick={this._payStaffSlot}
                disabled={Boolean(pendingBilling)}
              >
                Pay
              </button>
            </div>
            {pendingBilling && (
              <div className="col-xs-12" style={{ paddingTop: '10px' }}>
                <em className={styles['disable-payment-message']}>
                  There is a pending payment for {pendingBilling.invoice_number}
                  .
                  {pendingBilling.payment_type === 'credit_card'
                    ? ' Please wait 24 hours before making a new payment.'
                    : ' Please transfer full amount of the invoice within 3 days before making a new payment.'}
                </em>
                <p className={styles['payment-redirection']}>
                  Check your <Link to="/settings/billing">billing page</Link>{' '}
                  for transaction history
                </p>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  _hideModal = () => {
    this.props.dispatch(hidePurchaseStaffSlotModal());
  };

  _upButton = () => {
    const { formValues } = this.props;
    let value = formValues.slotNumber;

    value++;
    if (!isNaN(value) && value > 1) {
      this.props.dispatch(change('PurchaseStaffSlotForm', 'slotNumber', value));
    }
  };

  _downButton = () => {
    const { formValues } = this.props;
    let value = formValues.slotNumber;

    value--;
    if (!isNaN(value) && value > 0) {
      this.props.dispatch(change('PurchaseStaffSlotForm', 'slotNumber', value));
    }
  };

  _payStaffSlot = () => {
    const { formValues, featurePrice } = this.props;
    let billingData = {};
    if (formValues && featurePrice) {
      billingData = {
        type: 'FeatureBilling',
        feature_name: 'Slot Employee',
        total_amount: featurePrice.final_price * formValues.slotNumber,
        add_slot_count: formValues.slotNumber,
      };
    }
    this.props.dispatch(verifyAddStaffSlot(billingData));
  };
}

const mapForm = {
  form: 'PurchaseStaffSlotForm',
};

function mapStateToProps(state) {
  const {
    showPurchaseStaffSlotModal,
    featurePrice,
    pendingBilling,
  } = state.employee.staff;
  return {
    showPurchaseStaffSlotModal,
    formValues: getFormValues('PurchaseStaffSlotForm')(state),
    featurePrice,
    pendingBilling,
  };
}

export default connect(mapStateToProps)(
  reduxForm(mapForm)(PurchaseStaffSlotModal)
);
